import React from 'react';

import {
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import dayjs from 'dayjs';

import { Lesson } from '../../services/classes/types';
import {
  getLessonCode,
} from '../../utils/common/classes';

import {
  StyledCard,
} from './index.styles';

interface LessonChipProps {
  lesson?: Lesson;
  selected?: boolean,
  onSelect?: () => void,
  startDatetime?: number,
  isThisWeek?: boolean,
}

const LessonChip = ({
  lesson,
  selected = false,
  onSelect = () => {},
  startDatetime,
  isThisWeek = false,
}: LessonChipProps) => {
  const theme = useTheme();

  return (
    <StyledCard $selected={selected} $break={!lesson} $isThisWeek={isThisWeek} onClick={onSelect}>
      {
        lesson ? (
          <Stack direction="column">
            <Typography
              variant="body2"
              fontWeight={isThisWeek ? 'bold' : 'normal'}
              color={isThisWeek ? theme.palette.red.main : 'default'}
            >{dayjs(startDatetime ?? lesson.startDatetime).format('D MMM')}
            </Typography>
            <Typography>{getLessonCode(lesson)}</Typography>
          </Stack>
        ) : (
          <Stack direction="column">
            {startDatetime && (
              <Typography
                variant="body2"
                fontWeight={isThisWeek ? 'bold' : 'normal'}
                color={isThisWeek ? theme.palette.red.main : 'default'}
              >
                {dayjs(startDatetime).format('D MMM')}
              </Typography>
            )}
            <Typography>Break</Typography>
          </Stack>
        )
      }
    </StyledCard>
  );
};
export default LessonChip;
